import Layout from "../../elements/layout";

const points = [
  {
    label: "1000 Points",
    price: 10000,
  },
  {
    label: "2000 Points",
    price: 20000,
  },
  {
    label: "5000 Points",
    price: 50000,
  },
  {
    label: "10000 Points",
    price: 100000,
  },
];

export default function TopupPage() {
  return (
    <Layout>
      <div className="sk-py-2 sk-pl-5 sk-pr-7 sk-w-full">
        <div>
          <h2 className="sk-text-xl sk-font-semibold sk-mb-0">Topup Points</h2>
          <p className="sk-text-sm sk-text-neutral-400 sk-font-semibold">
            Topup points anda disini
          </p>
        </div>
        <section className="sk-mb-8 sk-grid sk-grid-cols-2 lg:sk-grid-cols-4 sk-gap-4">
          {points.map((point, index) => (
            <div
              key={index}
              className="sk-bg-white sk-shadow sk-rounded-2xl sk-p-4 sk-flex sk-flex-col lg:sk-flex-row lg:sk-items-center sk-items-start sk-justify-between"
            >
              <div>
                <h3 className="sk-text-base sk-font-semibold sk-my-0">
                  {point.label}
                </h3>
                <p className="sk-text-sm sk-text-neutral-400 sk-mb-0">
                  Rp. {point.price}
                </p>
              </div>
              <button className="lg:sk-ml-4 sk-mt-4 lg:sk-mt-0 sk-bg-primary sk-font-bold sk-text-white sk-rounded-xl !sk-px-4 !sk-py-2 !sk-border-none !sk-leading-normal !sk-text-xs !sk-h-fit">
                Topup
              </button>
            </div>
          ))}
        </section>
        <div>
          <h2 className="sk-text-xl sk-font-semibold sk-mb-0">
            Histori Transaksi
          </h2>
          <p className="sk-text-sm sk-text-neutral-400 sk-font-semibold">
            Histori transaksi topup points anda
          </p>
        </div>
        <section className="sk-shadow sk-rounded-xl sk-py-2">
          <table
            className="sk-w-full sk-border-none"
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th className="sk-text-left sk-text-neutral-400 sk-font-semibold sk-text-sm sk-py-3 !sk-border-none">
                  Tanggal
                </th>
                <th className="sk-text-left sk-text-neutral-400 sk-font-semibold sk-text-sm sk-py-3 !sk-border-none">
                  Jumlah Points
                </th>
                <th className="sk-text-left sk-text-neutral-400 sk-font-semibold sk-text-sm sk-py-3 !sk-border-none">
                  Harga
                </th>
                <th className="sk-text-left sk-text-neutral-400 sk-font-semibold sk-text-sm sk-py-3 !sk-border-none">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  12/12/2021
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  1000 Points
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  Rp. 10000
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">Success</td>
              </tr>
              <tr>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  12/12/2021
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  2000 Points
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  Rp. 20000
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">Success</td>
              </tr>
              <tr>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  12/12/2021
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  5000 Points
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  Rp. 50000
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">Success</td>
              </tr>
              <tr>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  12/12/2021
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  10000 Points
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">
                  Rp. 100000
                </td>
                <td className="sk-text-sm sk-py-3 !sk-border-none">Success</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </Layout>
  );
}
